var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"homeindex",attrs:{"direction":"horizontal"}},[_c('el-aside',[_c('TheMenu')],1),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('router-view',{key:_vm.key})],1),_c('el-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }